export const SHOW_POPUP = 'SHOW_POPUP';

/**
 * Intercept a typical anchor tag event and open a popup window with the target href
 * @param event
 * @param cfg
 * @returns {{type: string, url: *}}
 */
export const showPopup = (event = {}, customConfig = {}) => {
    if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
    }

    const target = event.currentTarget || {};
    let left = 0;
    let top = 0;
    let features = '';

    const config = {
        popupUrl: customConfig.url || target.href || '',
        popupWindowName: 'popup',
        centered: (typeof customConfig.centered !== 'undefined') ? customConfig.centered : true,
        width: customConfig.width || 900,
        height: customConfig.height || 500,

        popupWindowFeatures: {
            location: customConfig.location || 1,
            status: customConfig.status || 1,
            scrollbars: customConfig.scrollbars || 1,
            resizable: customConfig.resizable || 1,
            toolbar: customConfig.toolbar || 0,
            menubar: customConfig.menubar || 0
        }
    };

    /**
     * Figure out where to position the popup on the screen
     */
    if (config.centered) {
        // calculate positioning for centering
        if (window.outerWidth) {
            left = Math.round((window.outerWidth - config.width) / 2) + window.screenX;
            top = Math.round((window.outerHeight - config.height) / 2) + window.screenY;
        } else if (window.screen.width) {
            left = Math.round((window.screen.width - config.width) / 2);
            top = Math.round((window.screen.height - config.height) / 2);
        }
    }

    // put together WindowFeatures, since, window.open needs it as a string
    for (const key in config.popupWindowFeatures) {
        features += key + '=' + config.popupWindowFeatures[key] + ',';
    }

    features += ',width=' + config.width + ',height=' + config.height + ',left=' + left + ',top=' + top;

    const popup = window.open(config.popupUrl, config.popupWindowName, features);

    if (popup && typeof popup.focus === 'function') {
        popup.focus();
    }
    
    return {
        type: SHOW_POPUP,
        url: config.popupUrl
    };
};

export default showPopup;
